import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
    name: 'user',
    initialState: {},
    reducers: {
        setUser: (state, action) => {
            return action.payload
        }
    }
});

export const refreshTokenIntervalSlice = createSlice({
    name: 'refreshTokenInterval',
    initialState: null,
    reducers: {
        setRefreshTokenInterval: (state, action) => {
            return action.payload
        }
    }
});

export const constantStore = createSlice({
    name: 'constatnt',
    initialState: {
        screenName: ""
    },
    reducers: {
        setScreenName: (state, action) => {
            return {
                ...state,
                screenName: action.payload
            }
        }
    }
});

export const resizeSlice = createSlice({
    name: 'resize',
    initialState: {
        windowInnerWidth: null
    },
    reducers: {
        setResizeData: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        }
    }
});

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleSidebar: (state) => {
            state.isOpen = !state.isOpen;
        },
        setSideBar: (state, action) => {
            return {...state, isOpen: action.payload};
        }
    },
});